import React from 'react';
import Text from 'src/@vymo/ui/atoms/text';
import { Card } from 'src/@vymo/ui/blocks';
import { Keys, locale } from 'src/i18n';
import { CommitData } from '../types';
import { CommitList } from './commitList';
import styles from './index.module.scss';

export interface BranchItemData {
  branch: string;
  lastModified: string;
  commits: Array<CommitData>;
  children?: Array<{
    branch: string;
    lastModified: string;
    commits: Array<CommitData>;
  }>;
}

export function BranchItem({
  branch,
  lastModified,
  commits,
  children = [],
}: BranchItemData) {
  return (
    <div className={styles.releaseBranchHistory__item}>
      <div className={styles.releaseBranchHistory__item__content}>
        <Card>
          <div className={styles.releaseBranchHistory__item__content__branch}>
            {branch}
          </div>
          <Text
            classNames={
              styles.releaseBranchHistory__item__content__last_modified
            }
          >
            {locale(Keys.LAST_MODIFIED)}:{lastModified}
          </Text>
          {commits?.length > 0 && <CommitList commits={commits} />}
        </Card>
      </div>
      {children?.length > 0 && (
        <div className={styles.releaseBranchHistory__item__children}>
          {children.map(
            ({
              branch: childBranch,
              lastModified: childLastModified,
              commits: childCommits,
            }) => (
              <BranchItem
                key={childBranch}
                branch={childBranch}
                lastModified={childLastModified}
                commits={childCommits}
              />
            ),
          )}
        </div>
      )}
    </div>
  );
}
